import { useQuery } from "@tanstack/react-query";
import { PagedResponse } from "src/utils/types";
import { axiosCompanyInstance } from "src/config/axios";
import { SessionModel, SessionStatus } from "../types/Session";
import { removeEmptyKeysFromFilters } from "src/utils/object";
import { CustomerTypes } from "src/modules/customer/types/Customer";

export const RQ_SESSION_LIST_KEY = "SESSION_LIST_KEY";

export type SessionListResponse = PagedResponse<SessionModel[]>;

export type SessionListFilters = {
    id?: string;
    stationId?: string;
    locationId?: string;
    status?: SessionStatus;
    customerType?: CustomerTypes;
    customer?: string;
    from?: string;
    to?: string;
    paymentFrom?: string;
    paymentTo?: string;
};

export const useSessionList = (
    page: number,
    perPage: number,
    searchFilters: SessionListFilters
) => {
    const filters: SessionListFilters = removeEmptyKeysFromFilters(searchFilters);

    return useQuery({
        queryKey: [RQ_SESSION_LIST_KEY, page, perPage, filters],
        queryFn: async (): Promise<SessionListResponse | null> => {
            const resp = await axiosCompanyInstance.get(`session`, {
                params: {
                    ...filters,
                    from: filters.from ? filters.from + " 00:00:00" : undefined,
                    to: filters.to ? filters.to + " 23:59:59" : undefined,
                    paymentFrom: filters.paymentFrom
                        ? filters.paymentFrom + " 00:00:00"
                        : undefined,
                    paymentTo: filters.paymentTo ? filters.paymentTo + " 23:59:59" : undefined,
                    page: page + 1,
                    perPage,
                },
            });

            return resp?.data || null;
        },
    });
};
